<template>
  <teleport to="#modalTeleport">
    <ConfirmModal ref="confirmModal"></ConfirmModal>
  </teleport>
  <h1>Crewmitglieder</h1>
  <hr />
  <h1 class="small">Insgesamt: {{ users.length }}, davon {{ helfer }} Crew</h1>
  <div class="input-group mb-3">
    <input
      type="text"
      aria-label="Suche"
      placeholder="Suche"
      v-model="search"
      class="form-control"
    />
    <select v-model="searchRole" class="form-control" style="max-width: 200px;">
      <option :value="0">--- Auswählen ---</option>
      <option :value="1">Crew</option>
      <option :value="2">Rezeption</option>
      <option :value="3">Teamlead</option>
      <option :value="4">Admin</option>
    </select>
    <select v-model="sortByCombo" class="form-control" style="max-width: 200px;">
      <option :value="'last_name ASC'">Nachname ↑</option>
      <option :value="'last_name DESC'">Nachname ↓</option>
      <option :value="'first_name ASC'">Vorname ↑</option>
      <option :value="'first_name DESC'">Vorname ↓</option>
      <option :value="'shiftlen ASC'">Schichten ↑</option>
      <option :value="'shiftlen DESC'">Schichten ↓</option>
    </select>
  </div>
  <template v-for="user of searchResults" :key="user.id">
    <div class="volunteer mb-4">
      <div>
        <div class="avatar">
          <img
            :src="user.avatar"
            class="rounded-circle border border-dark"
            alt="Avatar"
          />
        </div>
        <div class="contact-info">
          <RouterLink :to="`/user/${user.id}`" v-if="isAdmin">{{
            user.full_name
          }}</RouterLink>
          <span v-if="!isAdmin">{{ user.full_name }}</span
          ><br />
          {{ user.email }}<br />
          <a :href="`tel:${user.phone}`">{{ user.phone_nice }}</a>
        </div>
      </div>
      <div class="system-info">
        <div class="comment d-none d-md-inline-block">
          <b>Kommentar</b> <br />
          <span
            v-if="user.comment && !user.editComment"
            @click="user.editComment = !user.editComment"
            style="cursor: pointer"
            >{{ user.comment }}</span
          >
          <button
            v-if="!user.comment && !user.editComment"
            @click="user.editComment = !user.editComment"
            class="btn btn-info btn-sm"
          >
            Setzen
          </button>
          <input
            type="text"
            v-model="user.comment"
            v-if="user.editComment"
            class="form-control"
            aria-label="Kommentar"
          />
          <button
            v-if="user.editComment"
            @click="
              setComment(user);
              user.editComment = !user.editComment;
            "
            class="btn btn-info btn-sm"
          >
            Speichern
          </button>
        </div>
        <span v-if="!hide_tshirts"
          >Hat <span v-if="!user.has_shirt">kein </span> Shirt:
          {{ $filters.shirtSizeName(user.shirt_size) }}<br
        /></span>
        {{ user.shifts ? user.shifts.length : 0 }} Schicht(en)<br />
        <span v-if="user.ticket"
          >Ticket versendet:
          <span
            class="fa fa-ticket"
            :class="{
              'text-success': user.ticket.ticket_sent,
              'text-danger': !user.ticket.ticket_sent,
            }"
          ></span
          ><br
        /></span>
        <span>{{ $filters.roleName(user.role) }}</span>
      </div>
    </div>
    <hr class="mb-4 volunteer-hr" />
  </template>

  <template v-if="isAdmin">
    <h3>Administrative Funktionen</h3>
    <ul>
      <li>
        <RouterLink to="/user/new">Neues Crewmitglied anlegen</RouterLink>
      </li>
      <li>
        <a href="#" @click.prevent="weHaveNewShirts()"
          >Alle User auf "hat kein Shirt" setzen</a
        >
      </li>
      <li>
        <RouterLink to="/user/broadcast">Broadcast SMS verschicken</RouterLink>
      </li>
      <li>
        <RouterLink to="/user/broadcast/mail"
          >Broadcast E-Mail verschicken</RouterLink
        >
      </li>
    </ul>
  </template>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import { useUserStore } from "@/stores/user.js";
import userService from "@/services/user.service.js";
import md5 from "md5";
import { useConfigStore } from "@/stores/config";
import ConfirmModal from "@/components/ConfirmModal.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "UsersView",
  components: { ConfirmModal },
  data() {
    return {
      users: [],
      helfer: 0,
      search: "",
      searchRole: 0,
      sortByCombo: "last_name ASC"
    };
  },
  async beforeRouteEnter(to, from, next) {
    let helfer = 0;
    let users = {};
    try {
      let response = await userService.index(true);
      for (let user of response.data) {
        user.avatar = `https://www.gravatar.com/avatar/${md5(user.email)}?d=mp`;
        user.shiftlen = user.shifts ? user.shifts.length : 0
        if (user.role === 1) {
          helfer++;
        }
      }
      users = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    next((vm) => {
      vm.users = users;
      vm.helfer = helfer;
    });
  },
  computed: {
    ...mapState(useUserStore, ["user", "isAdmin", "isTeamlead"]),
    ...mapState(useConfigStore, [
      "ticketing_enabled",
      "guests_enabled",
      "hide_tshirts",
    ]),
    sortBy() {
      return this.sortByCombo.split(" ")[0]
    },
    sortByDirection() {
      return this.sortByCombo.split(" ")[1] == "ASC" ? -1 : 0
    },
    searchResults() {
      var users = JSON.parse(JSON.stringify(this.users));
      if (this.searchRole) {
        var role = this.searchRole;
        users = users.filter(function (user) {
          return user.role === role
        })
      }
      if (this.search) {
        var s = this.search.toLowerCase();
        users = users.filter(function (user) {
          if (
            user.full_name.toLowerCase().indexOf(s) >= 0 ||
            user.email.toLowerCase().indexOf(s) >= 0 ||
            user.phone.indexOf(s) >= 0
          ) {
            return true;
          }
          return false;
        });
      }
      var sortBy = this.sortBy
      var sortByDirection = this.sortByDirection
      return users.sort(function (a, b) {
        // -1 = a erst
        // 0 = gleich
        // 1 = b erst
        let value = -1
          if (a[sortBy] > b[sortBy]) {
            value = 1
          }
        if (!sortByDirection) {
          value *= -1
        }
        return value
      });
    },
  },
  methods: {
    async getUsers() {
      try {
        this.helfer = 0;
        let response = await userService.index(true);
        for (let user of response.data) {
          user.avatar = `https://www.gravatar.com/avatar/${md5(user.email)}?d=mp`;
          user.shiftlen = user.shifts.length
          if (user.role === 1) {
            this.helfer++;
          }
        }
        this.users = response.data;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    },
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async weHaveNewShirts() {
      if (
        await this.$refs.confirmModal.show(
          "",
          `Sollen wirklich alle Shirts resettet werden? Du kannst das nicht rückgängig machen!`
        )
      ) {
        try {
          await userService.weHaveNewShirts();
          await this.getUsers();
          this.addAlert("success", "Alle Shirts wurden zurückgesetzt.");
          window.scrollTo(0, 0);
        } catch (e) {
          if (e) {
            Sentry.captureException(e);
            this.addAlert(
              "danger",
              "Es ist was unerwartetes schief gegangen.."
            );
            window.scrollTo(0, 0);
          }
        }
      }
    },
    async setRole(user) {
      await this.updateUser(user, "role");
    },
    async setComment(user) {
      try {
        await userService.comment(user.id, user.comment);
        this.addAlert("success", "Der Nutzer wurde erfolgreich bearbeitet.");
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    },
    async updateUser(user, property) {
      try {
        let updates = {};
        updates[property] = user[property];
        await userService.update(user.id, updates);
        this.addAlert("success", "Der Nutzer wurde erfolgreich bearbeitet.");
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.volunteer {
  justify-content: space-between;
  display: flex;
  position: relative;

  .arrival-state {
    font-size: 25px;
    vertical-align: middle;
  }

  .contact-info {
    vertical-align: middle;
    display: inline-block;
    margin-left: 10px;
  }

  .avatar {
    display: inline-block;
    max-width: 50px;
    margin-left: 10px;

    img {
      width: 100%;
      height: auto;
      max-height: 50px;
    }
  }

  .system-info {
    text-align: right;
  }

  .comment {
    position: absolute;
    right: 170px;
    max-width: 300px;
  }
}

.volunteer-hr {
  width: 90%;
  opacity: 0.2;
}
</style>
